import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import RewardForm, { RewardFormValues } from "../components/rewards/RewardForm";
import { useAddReward } from "../services/rewards";
import ROUTES from "../utils/ROUTES";
import { toast } from "../hooks/use-toast";
import axios from "axios";

const getErrorMessage = (err: unknown): string =>
  axios.isAxiosError(err) ? err.response?.data?.error ?? err.message : "Something went wrong. Please try again.";

const AddReward = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const { mutate: addReward, isPending } = useAddReward();

  const handleSave = (values: RewardFormValues) => {
    addReward(values, {
      onSuccess: () => {
        toast({ variant: "success", title: "Reward created", description: "Your new reward has been successfully added." });
        navigate(ROUTES.REWARDS);
      },
      onError: (err) => {
        toast({ variant: "error", title: "Failed to create reward", description: getErrorMessage(err) });
      },
    });
  };

  return (
    <div className="flex h-screen overflow-hidden bg-surface-page">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="flex-1 min-w-0 overflow-y-auto px-4 sm:px-8 lg:pl-11 lg:pr-8 pt-6 lg:pt-[60px] pb-16">
        {/* Mobile hamburger */}
        <div className="flex items-center mb-4 lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg hover:bg-black/5 transition-colors"
            aria-label="Open menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="#012926" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        <h1
          className="text-[28px] sm:text-[34px] uppercase tracking-[0.68px] leading-none text-brand-dark"
          style={{ fontFamily: '"Bebas Neue", sans-serif' }}
        >
          Add New Reward
        </h1>
        <p className="mt-3 text-[14px] sm:text-[16px] font-medium text-content-label">
          Create a new reward for your loyalty program members.
        </p>

        <div className="mt-8 lg:mt-[36px] max-w-[660px] mx-auto">
          <RewardForm onSave={handleSave} isPending={isPending} />
        </div>
      </main>
    </div>
  );
};

export default AddReward;
